<template>
  <section class="gallery-section">
    <h2 v-if="header">{{ $t(header) }}</h2>
    <div class="gallery-section-img-container">
      <img v-for="(photo, idx) in photos" width="302" height="220" :key="idx" :src="imageUrlWithProxy(photo, 548, 380, 'fit')" :alt="`Activity photo ${idx + 1}`" loading="lazy">
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  header: {type: String, required: false},
  photos: {type: Array<string>, default: [], required: true},
})

//use imageUrlWithProxy from image.ts
import { imageUrlWithProxy } from '../../utils/imageproxy'

</script>

<style scoped lang="scss">

.gallery-section {
  color: var(--black);

  h2 {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    padding-bottom: 8px;
    padding-top: 16px;
  }

  .gallery-section-img-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;

    img {
      border-radius: 8px;
      object-fit: cover;
      width: 100%;
      height: 240px;

      @media (max-width: 768px) {
        grid-column: span 2;
        height: 220px;
      }
    }
  }
}

</style>
